export const tabs = {
  edit: 'EDIT',
  scoring: 'SCORING',
  preview: 'PREVIEW',
};

export const validationActionTypes = {
  hasName: 'hasName',
  hasStimulus: 'hasStimulus',
  hasAllOptionsFilled: 'hasAllOptionsFilled',
  hasOneCorrectOptionSelected: 'hasOneCorrectOptionSelected',
  hasAllRequiredTagsSelected: 'hasAllRequiredTagsSelected',
  hasTagSelected: 'hasTagSelected',
  hasQuestion: 'hasQuestion',
  scoringSectionErrors: 'scoringSectionErrors',
  clear: 'clear',
};
